angular.
module("digiexam.components").
directive("uiAnimate", function uiAnimateDirective($timeout) {
	"use strict";

	return {
		restrict: "A",

		link: function link($scope, element, attrs) {
			var animClass = attrs.uiAnimate || "ui-animate";
			element.addClass(animClass);

			function removeFunc() {
				element.removeClass(animClass);
			}

			$timeout(removeFunc, 20, false);
		},
	};
});
